define('modules/campaigns/modal/remove_zones_modal_view',[
  'backbone',
  'jquery',
  '_',
  'text!./remove_zones_modal_template.html'
], function (Backbone, $, _,
             modal_template) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

      this.render();
    },

    tagName: 'div',
    className: 'zones-list-modal',
    template: _.template(modal_template),

    events: {
      'click .js-confirm-button': 'confirmRemoveZones',
      'click input[type="checkbox"]': 'onInputChange'
    },

    render: function () {
      this.$el.html(this.template(this.fields));
      return this;
    },

    onInputChange: function (e) {
      // console.log('onInputChange', e.currentTarget.value);
      var changedZoneCheckbox = e.currentTarget.value;

      if (!changedZoneCheckbox) { return; }

      if (changedZoneCheckbox == 'all') {

        var allCheckbox = $('.pick-this input[type="checkbox"][value="all"]');

        var zoneCheckboxes = $('.or-these input[type="checkbox"][value!="all"]');
        _.forEach(zoneCheckboxes, function(inputElement) {
          if (!inputElement.disabled) {
            inputElement.checked = allCheckbox.prop('checked');
          }
        });

      } 
      
      this.setOKButtonStatus();

    },

    setOKButtonStatus: function () {

      var enableOKButton = false;

      var allCheckbox = $('.pick-this input[type="checkbox"][value="all"]').first();

      var zoneCheckboxes = $('.or-these input[type="checkbox"][value!="all"]');

      // console.log('allCheckbox', allCheckbox, allCheckbox.prop('checked'));
      if (allCheckbox.prop('checked') === true) { enableOKButton = true; }

      _.forEach(zoneCheckboxes, function(inputElement) {
        
        // console.group('inputElement:', inputElement.value);
        // console.log('checked:', inputElement.checked);
        // console.log('disabled:', inputElement.disabled);
        // console.groupEnd();

        if (inputElement.disabled !== inputElement.checked) {
          enableOKButton = true;
        }

      });

      $('.js-confirm-button').first().attr('disabled', !enableOKButton);      

    },


    confirmRemoveZones: function (e) {
      e.preventDefault();

      var selectedZones = [];
      var zoneCheckboxes = $('.or-these input[type="checkbox"][value!="all"]');

      // console.log('zoneCheckboxes',zoneCheckboxes);

      _.forEach(zoneCheckboxes, function(inputElement) {
        // console.log('inputElement.prop',inputElement, inputElement.checked);
        if (inputElement.checked) {
          selectedZones.push(inputElement.value);
        }
      });

      // Backbone.trigger('campaigns:removezones', {'removedZones': selectedZones});
      Backbone.trigger('campaigns:removezones', {'operationType': 'remove', 'selectedZones': selectedZones});

      this.trigger('close');
    },

    remove: function () {
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    }
  });
  return View;
});

